"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Icon = styled_components_1.default.i
    .withConfig({
    shouldForwardProp: function (prop, defaultValidatorFn) {
        return !['name'].includes(prop) && defaultValidatorFn(prop);
    },
})
    .attrs(function (_a) {
    var name = _a.name;
    return ({
        className: "r95 " + name,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
exports.default = Icon;
var templateObject_1;
//# sourceMappingURL=Icon.js.map